import regionCardIcon1 from '@/assets/icons/region-card-icon-1.svg'
import regionCardIcon2 from '@/assets/icons/region-card-icon-2.svg'
import regionCardIcon3 from '@/assets/icons/region-card-icon-3.svg'
import regionCardIcon4 from '@/assets/icons/region-card-icon-4.svg'

export const REGION_CARD_ICONS = [
  regionCardIcon1,
  regionCardIcon2,
  regionCardIcon3,
  regionCardIcon4,
]

export const REGION_CARD_BG_COLORS = [
  'blue-600',
  'yellow-600',
  'green-600',
  'red-600',
]

export const REGION_CARD_COLOR_CLASS_MAP: {
  [key: string]: { bg: string; border: string; hover: string }
} = {
  'blue-600': {
    bg: 'bg-blue-600/10',
    border: 'border-blue-600',
    hover: 'hover:bg-blue-600/10',
  },
  'yellow-600': {
    bg: 'bg-yellow-600/10',
    border: 'border-yellow-600',
    hover: 'hover:bg-yellow-600/10',
  },
  'green-600': {
    bg: 'bg-green-600/10',
    border: 'border-green-600',
    hover: 'hover:bg-green-600/10',
  },
  'red-600': {
    bg: 'bg-red-600/10',
    border: 'border-red-600',
    hover: 'hover:bg-red-600/10',
  },
}
